import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';

class StickyAddToCart extends HTMLElement {
  #unsubscribe;
  #observer;

  connectedCallback() {
    this.#observeProductForm();

    this.#unsubscribe = PubSub.subscribe('variant:change', ({ id, data: { html } }) => {
      if (id !== this.dataset.productId) return;

      // product-form.js replaces the whole <form> on this same event. Stop
      // watching the node that is about to be detached, swap our own contents,
      // then re-observe the fresh form once the DOM has settled — otherwise the
      // sticky bar ends up bound to a removed element and never shows again.
      this.#observer?.disconnect();
      this.#handleVariantChange(html);
      requestAnimationFrame(() => this.#observeProductForm());
    });
  }

  disconnectedCallback() {
    this.#unsubscribe();
    this.#observer?.disconnect();
  }

  /**
   * Handle variant changes.
   * @param {HTMLElement} html - The HTML to render.
   */
  #handleVariantChange(html) {
    const stickyAddToCart = html.querySelector('sticky-add-to-cart');
    this.innerHTML = stickyAddToCart.innerHTML;
  }

  /**
   * Observe the product form so the sticky bar shows once it is scrolled past.
   */
  #observeProductForm() {
    const addToCartForm = document.querySelector('[data-type="add-to-cart-form"]');
    if (!addToCartForm) return;

    this.#observer?.disconnect();
    this.#observer = new IntersectionObserver(([{ isIntersecting, boundingClientRect }]) => {
      const scrolledPast = !isIntersecting && boundingClientRect.bottom < 0;

      this.classList.toggle('translate-y-0', scrolledPast);
      this.classList.toggle('translate-y-full', !scrolledPast);
      this.classList.toggle('opacity-0', !scrolledPast);
    });

    this.#observer.observe(addToCartForm);
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
